/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getTransactionTable = /* GraphQL */ `
  query GetTransactionTable($id: ID!) {
    getTransactionTable(id: $id) {
      id
      SerialNumber
      CustomerName
      Barcode
      InsertTime
      Data
      Error
      createdAt
      updatedAt
    }
  }
`;
export const listTransactionTables = /* GraphQL */ `
  query ListTransactionTables(
    $filter: ModelTransactionTableFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTransactionTables(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        SerialNumber
        CustomerName
        Barcode
        InsertTime
        Data
        Error
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getTransactionSetupTable = /* GraphQL */ `
  query GetTransactionSetupTable($id: ID!) {
    getTransactionSetupTable(id: $id) {
      id
      ExternalId
      WeightMap
      ImageMap
      createdAt
      updatedAt
    }
  }
`;
export const listTransactionSetupTables = /* GraphQL */ `
  query ListTransactionSetupTables(
    $filter: ModelTransactionSetupTableFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTransactionSetupTables(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        ExternalId
        WeightMap
        ImageMap
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getConnectionConfigTable = /* GraphQL */ `
  query GetConnectionConfigTable($id: ID!) {
    getConnectionConfigTable(id: $id) {
      id
      Name
      AccountId
      Token
      TokenSecret
      ExternalUser
      RfsmartRestlet
      AutomationRestlet
      ExpirationDate
      CustomerName
      EmailAddress
      createdAt
      updatedAt
    }
  }
`;
export const listConnectionConfigTables = /* GraphQL */ `
  query ListConnectionConfigTables(
    $filter: ModelConnectionConfigTableFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listConnectionConfigTables(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        Name
        AccountId
        Token
        TokenSecret
        ExternalUser
        RfsmartRestlet
        AutomationRestlet
        ExpirationDate
        CustomerName
        EmailAddress
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getQboidConfigTable = /* GraphQL */ `
  query GetQboidConfigTable($id: ID!) {
    getQboidConfigTable(id: $id) {
      id
      SerialNumber
      CustomerName
      LengthField
      WidthField
      HeightField
      WeightField
      ImageField
      AltDimType
      AltLengthField
      AltWidthField
      AltHeightField
      AltWeightField
      AltImageField
      LengthUnit
      WeightUnit
      AlwaysRoundUpWeight
      AlwaysRoundUpLength
      WeightRoundingDigits
      LengthRoundingDigits
      InsertTime
      ConnectionName
      ExternalId
      AttributeMappings
      createdAt
      updatedAt
    }
  }
`;
export const listQboidConfigTables = /* GraphQL */ `
  query ListQboidConfigTables(
    $filter: ModelQboidConfigTableFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listQboidConfigTables(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        SerialNumber
        CustomerName
        LengthField
        WidthField
        HeightField
        WeightField
        ImageField
        AltDimType
        AltLengthField
        AltWidthField
        AltHeightField
        AltWeightField
        AltImageField
        LengthUnit
        WeightUnit
        AlwaysRoundUpWeight
        AlwaysRoundUpLength
        WeightRoundingDigits
        LengthRoundingDigits
        InsertTime
        ConnectionName
        ExternalId
        AttributeMappings
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
